// extracted by mini-css-extract-plugin
export default {"screen-middle":"Loading_screen-middle__0vuwH"};